import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class ToastService {

    constructor(private toastController: ToastController) {
    }

    presentErrorToast(errorMessage: string): void {
        this.toastController.create({
            message: errorMessage,
            duration: 3000,
            color: 'danger'
        }).then(toast => toast.present());
    }

    presentOkToast(message: string): void {
        this.toastController.create({
            message,
            duration: 3000
        }).then(toast => toast.present());
    }
}
